{
    "general": {
        "buttons": {
            "newAddress": "Nouvelle adresse",
            "back": "retour",
            "useAddress": "Utiliser",
            "closeModal": "Fermer",
            "confirmSelection": "Confirmer la sélection",
            "addressesSelected": {
                "singular": "adresse sélectionnée",
                "plural": "adresses sélectionnées"
            },
            "cancel": "Annuler",
            "next": "Suivant",
            "addArea": "Ajouter une zone"
        },
        "labels": {
            "zipcode": "code postal",
            "zipcodePlaceholder": "0000XX",
            "houseNumber": "Numéro de maison",
            "streetName": "nom de rue",
            "streetNamePlaceholder": "Exemple de rue",
            "addressFound": {
                "singular": "Adresse trouvée",
                "plural": "Adresses trouvées"
            },
            "houseNumberPlaceholder": "XX",
            "radiusLabel": "Rayon (m)",
            "houseValueLabel": "Valeur de la maison (x 1000 €)",
            "filterOn": "Filtre activé",
            "filterRentalOption": "Location",
            "filterSaleOption": "Vente",
            "adresses": {
                "singular": "adresse",
                "plural": "adresses"
            },
            "total": "Totale",
            "areas": "Zones",
            "selected": "choisi",
            "houseType": "Type de maison",
            "allTypes": "Tous les types",
            "clearSearch": "Effacer la recherche",
            "clearSelected": "Effacer la sélection",
            "noOptions": "Aucune option",
            "search": "Rechercher",
            "selectAll": "Tout sélectionner",
            "selectAllFiltered": "Tout sélectionner",
            "selectSomeItems": "Tous les types",
            "create": "Créer"
        },
        "houseTypes": {
            "Appartement": "Appartement",
            "Vrijstaande woning": "Maison individuelle",
            "Tussenwoning": "Maison mitoyenne",
            "Hoekwoning": "Maison d'angle",
            "2-onder-1-kapwoning": "Maison jumelée"
        },
        "messages": {
            "addressNotFound": {
                "singular": "Aucune adresse trouvée",
                "plural": "Aucune adresse trouvée"
            },
            "addressNotFoundForSelected": "aucune adresse trouvée pour:",
            "addressesNotFoundForSelection": "Aucune adresse trouvée pour la sélection",
            "generalError": "Oups! Quelque chose s'est mal passé.",
            "addressLimitExceeded": {
                "singular": "Vous ne pouvez sélectionner que {{max}} adresses. {{count}} adresse ne sera pas sélectionnée.",
                "plural": "Vous ne pouvez sélectionner que {{max}} adresses. {{count}} adresses ne seront pas sélectionnées."
            },
            "addressMinimum": "Sélectionnez au moins {{min}} adresses pour continuer.",
            "zipCodeAreaLimitError": "Au moins {{limit}} adresses doivent être sélectionnées par zone/région de code postal. Ajustez votre zone de recherche en augmentant le rayon ou en ajoutant une deuxième zone.",
            "zipCodeAreaSelectionLimitError": "Au moins {{limit}} adresses doivent être sélectionnées par zone/région de code postal."
        }
    },
    "slideInPanel": {
        "header": {
            "title": "Adresses"
        },
        "tableColumnLabels": {
            "streetName": "Nom de la rue",
            "amountName": "Montant",
            "zipCodeArea": "Zone de code postal"
        },
        "content": {
            "noSelection": "Veuillez sélectionner des adresses à l'étape précédente"
        }
    },
    "summary": {
        "header": {
            "title": "Résumé"
        }
    },
    "filters": {
        "buttons": {
            "showMore": "Afficher plus de filtres",
            "showLess": "Afficher moins de filtres"
        },
        "household": {
            "label": "Ménage",
            "singles": "Personne seule",
            "families": "Familles",
            "familiesWithSmallChildren": "Familles avec de jeunes enfants ≤3 ans"
        },
        "buildingType": {
            "label": "Type de logement",
            "appartment": "Appartement",
            "midTerraceHouse": "Maison mitoyenne",
            "detachedHouse": "Maison individuelle",
            "terraceHouse": "Maison en rangée",
            "doubleHouse": "Maison jumelée",
            "smallBlockFlat": "Petit immeuble d'appartements",
            "largeBlockFlat": "Grand immeuble d'appartements",
            "highRiseBuilding": "Immeuble de grande hauteur",
            "cornerHouse": "Maison d'angle"
        },
        "buildingUsage": {
            "label": "Usage du bâtiment",
            "unknown": "Inconnu",
            "residential": "Résidentiel",
            "mixedUse": "Usage mixte",
            "commercial": "Usage commercial"
        },
        "buyRatio": {
            "label": "Filtre sur le taux de propriété"
        },
        "buildYear": {
            "label": "Filtre sur l'annee de construction"
        },
        "livingArea": {
            "label": "Filtrer par surface habitable"
        },
        "scaleText": {
            "extremeLow": "Extrêmement faible",
            "veryLow": "Très faible",
            "low": "Faible",
            "medium": "Moyen",
            "middleHigh": "Moyennement élevé",
            "high": "Élevé",
            "veryHigh": "Très élevé",
            "extremeHigh": "Extrêmement élevé"
        },
        "residenceLength": {
            "label": "Filtrer par durée de résidence",
            "lessThanOneYear": "Jusqu'à 1 an",
            "betweenOneAndTwoYears": "Jusqu'à 2 ans",
            "betweenTwoAndThreeYears": "Jusqu'à 3 ans",
            "betweenThreeAndFourYears": "Jusqu'à 4 ans",
            "betweenFourAndFiveYears": "Jusqu'à 5 ans",
            "betweenFiveAndSixYears": "Jusqu'à 6 ans",
            "betweenSixAndEightYears": "Jusqu'à 8 ans",
            "betweenEightAndTenYears": "Jusqu'à 10 ans",
            "moreThanTenYears": "Plus de 10 ans"
        },
        "purchasingPowerClass": {
            "label": "Filtrer par classe de pouvoir d'achat",
            "farBelowAverage": "Très inférieur à la moyenne",
            "belowAverage": "Inférieur à la moyenne",
            "lowerAverage": "Légèrement inférieur à la moyenne",
            "average": "Moyenne",
            "upperAverage": "Légèrement supérieur à la moyenne",
            "aboveAverage": "Supérieur à la moyenne",
            "farAboveAverage": "Très supérieur à la moyenne"
        }
    }
}